// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "management-workflows" + "." + "10407424" + ".chunk.css";
};